import { render, staticRenderFns } from "./ProductsNew.vue?vue&type=template&id=e722dcd6"
import script from "./ProductsNew.vue?vue&type=script&lang=js"
export * from "./ProductsNew.vue?vue&type=script&lang=js"
import style0 from "./ProductsNew.vue?vue&type=style&index=0&id=e722dcd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProductsNew.vue?vue&type=custom&index=0&blockType=div&v-html=%24t('message.IntGeoloc')"
if (typeof block0 === 'function') block0(component)

export default component.exports